import { VSparkline } from 'vuetify/lib/components/VSparkline';

var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$apollo.loading)?_c(VSparkline,{attrs:{"value":_vm.rankingPnlSeries.datasets,"color":"#0436af","line-width":"4","smooth":"8","padding":"6","fill":true,"gradient":_vm.gradient,"gradient-direction":"top","auto-draw-duration":200,"auto-draw":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }